import styles from './RichText.module.scss';
import classNames from 'classnames/bind';
import React from 'react';

let cx = classNames.bind(styles);

export function RichText({ html, elem = 'div', className, ...props }) {
	const classNameArray = className?.split(' ') || [];

	return React.createElement(elem, {
		className: classNameArray.length === 0 || (classNameArray.length === 1 && classNameArray[0] === '') ? null : cx([...classNameArray]),
		dangerouslySetInnerHTML: { __html: html ?? '' },
		...props,
	});
}
